import {
  VideoItemType,
  VideoItemTypeApi,
  VideoType,
} from '@hhgtech/hhg-components/types'

import {
  CommonSessionType,
  CommonSessionTypeApi,
  FeatureVideoType,
  FeatureVideoTypeApi,
  HeadingBannerType,
  HeadingBannerTypeApi,
  SessionComponentType,
  SessionComponentTypeApi,
  SessionsType,
  VideosPageType,
  VideosPageTypeApi,
  VideosSessionListType,
} from 'interfaces/types/VideosPage'

import { wrapFormatFn } from './utils'

export const formatVideoItem = wrapFormatFn(
  (data?: VideoItemTypeApi | null): VideoItemType | null => {
    if (typeof data === 'undefined' || !data) return null

    return {
      id: data.ID || '',
      videoId: data.video_id || '',
      url: data.video_url || '',
      title: data.video_title || '',
      type: data.type || 'video',
      totalView: data.total_view || 0,
      description: data.description || '',
      createTime: data.create_time || '',
      duration: data.duration || 0,
      image: data.image || '',
      imageMedium: data.image_medium || '',
      imageThumbnail: data.image_thumbnail || '',
      active: false,
      articleLink: data.article_link || '',
    }
  },
)

export const formatHeaderBanner = wrapFormatFn(
  (data?: HeadingBannerTypeApi | null): HeadingBannerType | null => {
    if (typeof data === 'undefined' || !data) return null

    return {
      sessionLayout: data.session_layout || '',
      title: data.title || '',
      description: data.description || '',
      backgroundBanner: data.background_banner || '',
      fullWidthBanner: Boolean(data.full_width_banner),
      bannerMobile: data.banner_mobile || '',
      bannerDesktop: data.banner_desktop || '',
    }
  },
)

export const formatCommonProps = wrapFormatFn(
  (data?: CommonSessionTypeApi | null): CommonSessionType | null => {
    if (typeof data === 'undefined' || !data) return null

    return {
      sessionLayout: data.session_layout || '',
      title: data.title || '',
    }
  },
)

export const formatSessionComponent = wrapFormatFn(
  (data?: SessionComponentTypeApi | null): SessionComponentType | null => {
    if (typeof data === 'undefined' || !data) return null

    return {
      sessionLayout: data.session_layout || '',
      sessionId: data.session_id || '',
      title: data.title || '',
      layout: data.layout || '',
      videos: (data.videos || [])
        .map(formatVideoItem)
        .filter(Boolean) as VideoItemType[],
      readMore: data.read_more || '',
    }
  },
)

export const formatFeatureVideosWithTab = wrapFormatFn(
  (data?: FeatureVideoTypeApi | null): FeatureVideoType | null => {
    if (typeof data === 'undefined' || !data) return null

    return {
      sessionLayout: data.session_layout || '',
      title: data.title || '',
      videos: (data.videos || [])
        .map(formatVideoItem)
        .filter(Boolean) as VideoItemType[],
      tabList: (data.other_tab_name || []).map((i) => ({
        type: i.video_type || VideoType.VIDEO,
        name: i.tab_name || '',
      })),
    }
  },
)

export const formatVideosPage = wrapFormatFn(
  (data?: VideosPageTypeApi | null): VideosPageType | null => {
    if (typeof data === 'undefined' || !data) return null

    return {
      name: data.name || '',
      listSessions: (data.list_sessions || [])
        .map((i) =>
          i.session_layout === SessionsType.HeadingBanner
            ? formatHeaderBanner(i as HeadingBannerTypeApi)
            : i.session_layout === SessionsType.FeatureVideo
            ? formatFeatureVideosWithTab(i as FeatureVideoTypeApi)
            : formatSessionComponent(i as SessionComponentTypeApi),
        )
        .filter(Boolean) as VideosSessionListType[],
      metaTag: data.meta_tag || '',
      disableAd: Boolean(data.disable_ad),
    }
  },
)
